import { TBreacdcrumbData, TBreadcrumbsIdHelper } from 'components';
import { slugToCategoryName } from './categorySlug';
import { TLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.types';

export const createIdLinkFromTemplate = (
  template: string,
  value: string | number | Array<string | number>,
  localize?: TLocalize
): string => {
  const paramNames = template.split('/').filter((part) => part.startsWith(':'));
  console.log(value);
  if (typeof value === 'string' || typeof value === 'number') {
    console.log(value);
    return template.replace(paramNames[0], String(value));
  } else if (Array.isArray(value)) {
    return value.reduce((accumulator: string, incomeValue, index) => {
      return accumulator.replace(`/${paramNames[index]}/`, String(incomeValue));
    }, template) as string;
  }

  throw new Error(
    `Invalid parameter type. Expecrted string, number or array of string or number but got ${typeof value}`
  );
};

export const getBreadcrumbsListDataFromPath = (
  path: string,
  idHelpers?: Array<TBreadcrumbsIdHelper>,
  localize?: TLocalize
): TBreacdcrumbData[] => {
  const pathWithoutQuery = path.split('?')[0];
  const query = path.split('?')?.[1];
  const pathParts = pathWithoutQuery.split('/').filter((part) => part !== '');
  const breadcrumbsData: TBreacdcrumbData[] = [];

  pathParts.forEach((pathPart, pathPartIndex) => {
    console.log(slugToCategoryName(pathPart));
    const genericSlugLabel = localize?.(slugToCategoryName(pathPart)) as string;
    const idHelperLabel = idHelpers?.find(
      (idHelper) => idHelper.id === pathPart
    )?.title;
    const localizedLabel = localize?.(idHelperLabel) as string;

    breadcrumbsData.push({
      label:
        genericSlugLabel && typeof genericSlugLabel === 'string'
          ? genericSlugLabel
          : localizedLabel,
      to: `/${pathPart}${query ? `?${query}` : ''}`,
      isActive: pathPartIndex === pathParts.length - 1,
    });
  });

  return breadcrumbsData;
};
